export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    slug: "guobiao-majiang",
    name: "国标麻将",
    description: "中国官方认可的竞赛麻将标准，包含81个番种，讲究技术、策略与运气并重，是最具竞技性的麻将玩法。",
    icon: "ri-trophy-line",
    articleCount: 12,
  },
  {
    slug: "sichuan-majiang",
    name: "四川麻将",
    description: "流行于四川重庆地区，以血战到底为核心规则，缺一门、刮风下雨等特色玩法让游戏更加刺激。",
    icon: "ri-fire-line",
    articleCount: 10,
  },
  {
    slug: "guangdong-majiang",
    name: "广东麻将",
    description: "广东及港澳地区最流行的麻将玩法，包含鸡平胡、推倒胡等多种变体，简单易学，深受大众喜爱。",
    icon: "ri-star-line",
    articleCount: 8,
  },
  {
    slug: "majiang-jiqiao",
    name: "麻将技巧",
    description: "从入门到精通，系统学习麻将的策略与技巧，提升你的麻将水平，成为牌桌上的高手。",
    icon: "ri-lightbulb-line",
    articleCount: 15,
  },
  {
    slug: "majiang-wenhua",
    name: "麻将文化",
    description: "探索麻将的历史渊源、文化内涵与趣闻轶事，了解这项凝聚中华智慧的传统游戏。",
    icon: "ri-book-open-line",
    articleCount: 6,
  },
  {
    slug: "xinshou-rumen",
    name: "新手入门",
    description: "零基础学麻将，从认识麻将牌开始，循序渐进掌握基本规则与常用术语，快速上手。",
    icon: "ri-user-smile-line",
    articleCount: 9,
  },
];